import ProgressBar from "./ProgressBar";

const ProgressFile = ({ archivos }) => {
  return (
    <div className="row">
      <div className="card shadow mb-4">
        <div className="card-header py-6">
          <h5 className="fw-bold m-0 text-gray-500">Estado de Cargas</h5>
        </div>
        <div className="card-body text-gray-500">
          {archivos?.map((archivo, index) => (
            <ProgressBar key={index} archivo={archivo} />
          ))}
        </div>
      </div>
      <div className="card shadow"></div>
    </div>
  );
};
export default ProgressFile;
